import { computed } from 'vue'
import type { ComputedRef } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import type { LocationQuery } from 'vue-router'

import { useAntecipeAffiliateStore } from '@/pinia-store/useAntecipeAffiliateStore'

import {
  COMPETENCE_QUERY_KEY,
  buildCompetenceOptions,
  competenceQuery,
  resolveCompetence
} from './competence'
import type { CompetenceBounds, CompetenceOption } from './competence'

/**
 * Competência selecionada = `?competencia=` validada contra o `/me` do escopo atual.
 * `null` só enquanto o `/me` não chegou (as páginas só montam depois dele).
 */
export function useAffiliateCompetence(): {
  competence: ComputedRef<string | null>
  options: ComputedRef<CompetenceOption[]>
  setCompetence: (next: string) => void
} {
  const route = useRoute()
  const router = useRouter()
  const store = useAntecipeAffiliateStore()

  const bounds = computed<CompetenceBounds | null>(() =>
    store.me
      ? {
          firstCompetence: store.me.firstCompetence,
          openCompetence: store.me.openCompetence
        }
      : null
  )

  const competence = computed(() =>
    bounds.value ? resolveCompetence(route.query, bounds.value) : null
  )

  const options = computed(() =>
    bounds.value ? buildCompetenceOptions(bounds.value, store.competences) : []
  )

  function setCompetence(next: string): void {
    if (!bounds.value) return
    const query: LocationQuery = { ...route.query }
    delete query[COMPETENCE_QUERY_KEY]
    // Outra competência é outra lista: a paginação recomeça.
    delete query.page
    router.replace({ query: { ...query, ...competenceQuery(next, bounds.value) } })
  }

  return { competence, options, setCompetence }
}
